import script from "./ChangePasswordSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordSuccess.vue?vue&type=style&index=0&id=2c64a39c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c64a39c"]])

export default __exports__